import Select from 'react-select'
import React from "react";
import { Form } from 'react-bootstrap'
import { IListOption } from "../classes/Domain";
import * as _ from 'lodash';

interface IValidatableSelectProps {
    value: string | null,
    className?: string,
    placeholder?: string | null,
    options: Array<IListOption>,
    validated: boolean,
    validationError: string,
    disabled?: boolean,
    onChange?: (selectedOption: IListOption | null) => void;
}

interface IState {
    selectedOption: IListOption | null
}

export class ValidatableSelect extends React.Component<IValidatableSelectProps, IState> {
    constructor(props: IValidatableSelectProps) {
        super(props);

        this.onOptionChange = this.onOptionChange.bind(this);

        this.state = {
            selectedOption: null
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value && !prevState.value) {
            const option = _.find(nextProps.options, ['value', nextProps.value]);
            return option
                ? {
                    ...prevState,
                    selectedOption: option
                }
                : prevState;
        }

        return prevState;
    }

    onOptionChange(value: IListOption | null) {
        this.setState({ selectedOption: value }, () => {
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        });
    }

    render() {
        return (
            <div>
                <Select
                    options={this.props.options}
                    value={this.state.selectedOption}
                    placeholder={this.props.placeholder ? this.props.placeholder : "Please select"}
                    onChange={(v) => this.onOptionChange(v ? { value: v["value"], label: v["label"] } : null)}
                    className={`${this.props.className} ${this.props.validated ? (this.props.validationError ? "is-invalid" : "is-valid") : ""}`}
                    isClearable={false} />
                {this.props.validated && this.props.validationError
                    ? <Form.Control.Feedback type="invalid">
                        {this.props.validationError}
                    </Form.Control.Feedback>
                    : null
                }
            </div>
        );
    }
}

export default ValidatableSelect;